import { render, staticRenderFns } from "./RectangleButton.vue?vue&type=template&id=081eb122"
import script from "./RectangleButton.vue?vue&type=script&lang=js"
export * from "./RectangleButton.vue?vue&type=script&lang=js"
import style0 from "./RectangleButton.vue?vue&type=style&index=0&id=081eb122&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports